import axiosInstance from "../../../../axiosInstance";
import {
  success,
  error,
  info,
  warning,
} from "../../../../store/notification/actions";

// Get master products

export async function getMasterProducts(data) {
  // info("Loading...");
  if (data != null) {
    return axiosInstance
      .post("/masterProduct/getMasterProducts", {
        search: data.search,
        page_number: data.page_number,
        page_size: data.page_size,
      })
      .then((response) => {
        if (
          response.data.status === "success" &&
          response.data.data.length > 0
        ) {
          success("Records Loaded Successfully");
          return { message: "", hasError: false, data: response.data.data };
        } else {
          warning("No records found !!!");
          return { message: "No records found.", hasError: true, data: "" };
        }
      })
      .catch((err) => {
        error(err.response.data.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

// Edit master product

export async function editMasterProduct(data) {
  info("Saving Master product ...");
  if (data != null) {
    return axiosInstance
      .post("/masterProduct/editMasterProduct", {
        application_number: data.application_number,
        c_ndc: data.c_ndc,
        package_ndc: data.package_ndc,
        case_qty: data.case_qty,
        description: data.description,
        drug_schd: data.drug_schd,
        dosage_form: data.dosage_form,
        level_1_pack_size: data.level_1_pack_size,
        level_2_pack_size: data.level_2_pack_size,
        level_3_pack_size: data.level_3_pack_size,
        generic_cd: data.generic_cd,
        generic_status: data.generic_status,
        generic_description: data.generic_description,
        generic_seq_no: data.generic_seq_no,
        strength: data.strength,
        storage_temp: data.storage_temp,
        route: data.route,
        shape: data.shape,
        color: data.color,
        item_no: data.item_no,
        mfr_name: data.mfr_name,
        imprints: data.imprints,
        product_type: data.product_type,
        uom: data.uom,
        hazard: data.hazard,
        orange_code_book: data.orange_code_book,
        search: data.search,
        upc: data.upc,
        page_number: data.page_number,
        page_size: data.page_size,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Record updated successfully");
          return { message: "", hasError: false, data: response.data.data };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

// Get a master product by UPC

export async function getMasterProductByUpc(data) {
  info("Getting a record by UPC...");
  if (data != null) {
    return axiosInstance
      .post("/masterProduct/getMasterProduct", {
        upc: data.upc,
      })
      .then((response) => {
        if (response.data.status === "success") {
          success("Record retrieved successfully");
          return { message: "", hasError: false, data: response.data.data };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

// Get master product by barcode

export async function getMasterProductByBarcode(data) {
  info("Getting Details from barcode...");
  if (data != null) {
    return axiosInstance
      .post("/masterProduct/getMasterProductByBarcode", {
        barcode: data,
      })
      .then((response) => {
        if (
          response.data.status === "success" &&
          response.data.data.length > 0
        ) {
          success("Barcode Scanned successfully");
          return response.data.data;
        } else {
          error("Barcode is invalid or not present");
        }
      })
      .catch((err) => {
        error("Error during scanning barcode");
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function GetGenericStatusData() {
  return await axiosInstance
    .get("/masterProduct/getGenericStatusData")
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data;
      } else {
        return [];
      }
    })
    .catch((err) => {});
}
